import React, { Component } from 'react';
import _ from 'lodash';

class ValidationTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    addTabs = (data) => {
        let tabs = []
        if (data.length > 0) {
            data.map((item, key) => {
                tabs.push(<li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key ==this.props.tabStep ? "nav-link active" : "nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="false">{item.groupName}</a>
                </li>)
            })
        }
        return tabs
    }
    TotalPercent=(item)=>{
        let percent = 0;
        item.segments.map(perc=>{
            percent+=perc.percent
        })
        return percent
    }
    handleFocus = (event) => event.target.select();
    addTabContents = (data) => {
        let content = [];
        let percent = 0;
        if (data.length > 0) {
            data.map((item, key) => {
                let segments = _.orderBy(item.segments, ['orderId'], ['asc']);
                content.push(
                    <div id={item.groupName} className={key ===this.props.tabStep ? "tab-pane fade tabContentdiv show active" : "tab-pane fade tabContentdiv"} role="tabpanel" key={key}>
                        <table className="table table-bordered segmentSizeTable">
                            <thead>
                                <tr>
                                    <th scope="col">Segment</th>
                                    <th scope="col">Segment size(Percentage)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {segments.map((segment,index)=>{
                                    return <tr key={index}>
                                        <td>{segment.name}</td>
                                        <td><input type="number" value={Number(segment.percent).toString()} className="form-control" id={segment.segmentId} onChange={(e)=>this.props.onPercentChange(e,item.groupId)} onFocus={this.handleFocus}/></td>
                                    </tr>
                                })}
                                <tr>
                                    <td></td>
                                    <td><input type="text" className="form-control" value={this.TotalPercent(item)}/></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
            })
        }
        return content
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <ul className="nav nav-tabs ValidationTabs" role="tablist" id="myTab">
                        {this.props.tabs.length > 0 && this.addTabs(this.props.tabs)}
                    </ul>
                    <div className="tab-content ValidationTabcontent" id="myTabContent" >
                        {this.props.tabs.length > 0 && this.addTabContents(this.props.tabs)}
                    </div>
                </div>
            </div>
        )
    }
}

export default (ValidationTabs);



// WEBPACK FOOTER //
// ./src/components/Segmentation/SegmentSize/SizeTabs/SizeTabs.jsx